var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94 0c-.33 0-.61.21-.67.5L.22 8.46a.6.6 0 0 0-.02.17c0 .34.3.61.69.61h3.77l-1.02 6.03-.01.12c0 .34.3.62.68.62a.7.7 0 0 0 .61-.33l4.75-7.92v-.01c.07-.1.13-.22.13-.36 0-.34-.3-.61-.69-.61H5.34L7.68.87a.56.56 0 0 0 .06-.25c0-.34-.3-.62-.68-.62z"
  })));
};
export default SvgBolt;